import React from 'react';
import PropTypes from 'prop-types';
import { columnSizeByList } from 'Store/lists/constants';

import List from 'Components/List/List';
import ListTableHeader from 'Containers/ListTableHeader';
import StatsListRow from 'Containers/StatsListRow/StatsListRow';
import VirtualizedList from 'Containers/VirtualizedList/VirtualizedList';
import Loading from 'Components/Loading';

class StatsList extends React.PureComponent {
  render() {
    const { type, list, isLoading } = this.props;
    const ids = list ? list.filteredIds || list.ids : undefined;
    const rows = ids.map(id => ({
      id,
      ...list.data[id],
    }));

    return (
      <List
        allowXAxisScroll
        groupType="stats"
        type={type}
        virtualized
        containerHeight="100vh"
        listHeader={
          <ListTableHeader
            type={type}
            stickyOffset={0}
            headerStuck={false}
            sortColumn={list.sortColumn}
            columnIds={list.columnIds}
            columnSizes={columnSizeByList(type)}
            sortAscending={list.sortAscending}
            rowSize="med"
            listId={list.listId}
          />
        }
      >
        {isLoading ? (
          <Loading type="component" />
        ) : (
          <VirtualizedList
            itemCount={ids.length}
            itemSize={54}
            renderRow={index => {
              const row = rows[index];
              return (
                <StatsListRow
                  rowIndex={index}
                  key={`row-${row.id}`}
                  id={row.id}
                  data={row}
                  columnIds={list.columnIds}
                  columnSizes={columnSizeByList(type)}
                  rowSize="med"
                  type={type}
                  isNew={false}
                />
              );
            }}
          />
        )}
      </List>
    );
  }
}

StatsList.propTypes = {
  list: PropTypes.object,
  type: PropTypes.string,
  isLoading: PropTypes.bool,
};

export default StatsList;
